import {PlayerBase} from "../../player/player.base";
import {Component, Injector, ViewChild} from '@angular/core';
import {Observable, from, switchMap, of, takeUntil} from 'rxjs';
import {catchError, finalize, tap} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";

@Component({
  selector: 'app-camera',
  template: '<div #component><video #videoElm  style="position: absolute; width: 100%; height: 100%; top: 0px; left: 0px" ></video></div>',
  styleUrls: []
})
export class CameraComponent extends PlayerBase {
  @ViewChild('videoElm', {static: true} ) videoElm;

  stream;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        return from(navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
              facingMode: 'user',
              width: this.actualWidth,
              height: this.actualHeight,
            }
        }))
      }),
      switchMap( stream => {
        this.stream = stream;
        this.videoElm.nativeElement.srcObject = stream;
        this.videoElm.nativeElement.play();
        return of('a');
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }


  destroy(): void {
    if (this.stream!=null) {
      const tracks = this.stream.getTracks()
      tracks[0].stop();
      this.stream = null;
      this.videoElm.nativeElement.pause();
      this.videoElm.nativeElement.src="";
      this.videoElm.nativeElement.srcObject = null;
    }
    super.destroy();
  }
}
